import type { MealPlanResult } from '@/types/mealPlan'
import type { BaseSliceState } from '../../types'

export interface MealPlanResultsState extends BaseSliceState {
  mealPlanResults: MealPlanResult[]
}

export enum MealPlanResultsActionTypes {
  SET = 'mealPlanResults/set',
  SET_ERROR = 'mealPlanResults/error',
  CLEAR = 'mealPlanResults/clear'
}

export type MealPlanResultsAction =
  | { type: MealPlanResultsActionTypes.SET; payload: MealPlanResult[] }
  | { type: MealPlanResultsActionTypes.SET_ERROR; payload: string }
  | { type: MealPlanResultsActionTypes.CLEAR }
